import { FC, PropsWithChildren } from 'react';
import { IconType } from 'react-icons';
import { merge } from '../../utils/utility';
import { FramedIcon } from '../icon/FramedIcon';

interface SectionHeaderProps extends PropsWithChildren {
  title: string;
  Icon: IconType;
  className?: string;
  error?: boolean;
}

export const SectionHeader: FC<SectionHeaderProps> = ({ title, Icon, className, error = false, children }) => {
  return (
    <div className={merge(className, 'flex gap-3 items-center')}>
      <FramedIcon Icon={Icon} secondary={error} />
      <span className={merge("flex-1 text-3xl font-semibold", error ? "text-secondary-800" : "text-primary-800")}>{title}</span>
      <div>{children}</div>
    </div>
  );
};
